(function() {
  // Add custom code below this line

  function fixNewsletterPopup() {
    const newsletter = document.querySelector('popup-newsletter');
    if (!newsletter) return;
    const dialog = newsletter.querySelector('dialog');
    if (!dialog) return;

    let blockUntil = 0;

    const orig = dialog.show.bind(dialog);
    dialog.show = function() {
      const now = Date.now();
      if (now < blockUntil) return;
      blockUntil = now + 2000;
      orig();
    };

    const origModal = dialog.showModal.bind(dialog);
    dialog.showModal = function() {
      const now = Date.now();
      if (now < blockUntil) return;
      blockUntil = now + 2000;
      origModal();
    };
  }

  window.addEventListener('load', function() {
    setTimeout(fixNewsletterPopup, 300);
  });

  if (document.body.classList.contains('template-article')) {
    document.querySelectorAll('.container, [data-site-container]').forEach(function(el) {
      el.style.removeProperty('background-color');
    });
  }

  // ============================================================
  // PATCH hover-disclosure pour la barre collections JF
  // La barre .jf-cnav est DANS header-component, donc closest()
  // devrait trouver [data-header-wrapper] nativement.
  // Ce patch sert de filet de securite : si wrapper est null
  // (timing ou restructuration future), on le force.
  // ============================================================
  function patchJfCnavDisclosures() {
    var cnav = document.getElementById('jf-cnav') || document.querySelector('.jf-cnav');
    if (!cnav) return;

    var headerWrapper = document.querySelector('[data-header-wrapper]');
    if (!headerWrapper) return;

    cnav.querySelectorAll('hover-disclosure').forEach(function(el) {
      // Si le wrapper natif est null, forcer la reference
      if (!el.wrapper) {
        Object.defineProperty(el, 'wrapper', {
          get: function() { return headerWrapper; },
          configurable: true
        });
      }
      // Verifier aussi que disclosure existe
      if (!el.disclosure) {
        var key = el.getAttribute('aria-controls');
        if (key) {
          el.disclosure = document.getElementById(key);
        }
      }
    });
  }

  // Attendre que les custom elements soient definis et connectes
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(patchJfCnavDisclosures, 200);
    });
  } else {
    setTimeout(patchJfCnavDisclosures, 200);
  }
  // Re-patch apres chargement complet (theme.js defer)
  window.addEventListener('load', function() {
    setTimeout(patchJfCnavDisclosures, 300);
  });

  // ============================================================
  // Cacher "Nos incontournables" quand un sous-menu mobile est ouvert
  // ============================================================
  function watchMobileSubmenu() {
    var pane = document.querySelector('mobile-menu [data-sliderule-pane]');
    if (!pane) return;
    var scrollContainer = pane.closest('.drawer__content__scroll');
    if (!scrollContainer) return;

    var observer = new MutationObserver(function() {
      var level = parseInt(pane.getAttribute('data-sliderule-pane'), 10);
      if (level > 0) {
        scrollContainer.classList.add('submenu-open');
      } else {
        scrollContainer.classList.remove('submenu-open');
      }
    });
    observer.observe(pane, { attributes: true, attributeFilter: ['data-sliderule-pane'] });
  }

  window.addEventListener('load', function() {
    setTimeout(watchMobileSubmenu, 500);
  });

  // Mobile menu: cacher le degrade quand on est tout en bas
  window.addEventListener('load', function() {
    setTimeout(function() {
      var sc = document.querySelector('mobile-menu .drawer__content__scroll');
      var body = document.querySelector('mobile-menu .drawer__body');
      if (!sc || !body) return;
      sc.addEventListener('scroll', function() {
        var atBottom = sc.scrollHeight - sc.scrollTop - sc.clientHeight < 20;
        body.classList.toggle('at-bottom', atBottom);
      }, { passive: true });
    }, 500);
  });

  // ============================================================
  // Fix menu mobile + indicateur de scroll
  // 1. Debloquer le menu collections (overflow hidden le coupe)
  // 2. Injecter une fleche animee pour indiquer le scroll
  // ============================================================
  // Mobile menu fixes : tout gere en pur CSS dans jf-cnav-fix.css

  // ============================================================
  // Header toujours fixed + animation cnav au scroll
  //
  // 1. Desactiver le mecanisme sticky du theme (data-header-sticky)
  // 2. Injecter un spacer pour compenser le header fixed
  // 3. Scroll down => cnav cachee / scroll up => cnav visible
  // ============================================================
  function initFixedHeaderAndCnav() {
    var header = document.querySelector('header-component.header__wrapper');
    if (!header) return;

    var headerEl = header.querySelector('header.theme__header');
    var cnav = header.querySelector('.jf-cnav');

    // Desactiver le sticky du theme pour eviter le saut relative->fixed
    header.removeAttribute('data-header-sticky');

    // Mesurer l'announcement bar (section au-dessus du header)
    var headerSection = header.closest('.shopify-section');
    var announcement = headerSection
      ? headerSection.parentElement.querySelector('.page-announcement, [class*="announcement"]')
      : null;
    var announcementH = announcement ? announcement.offsetHeight : 0;

    // Positionner le header sous l'announcement bar au chargement
    header.style.setProperty('top', announcementH + 'px', 'important');

    // Injecter le spacer (compense header + announcement)
    if (headerSection) {
      var spacer = document.createElement('div');
      spacer.className = 'jf-header-spacer';
      spacer.style.width = '100%';
      headerSection.after(spacer);

      // JF 11 oct 2026 : le spacer compense toute la hauteur du header fixe
      // (header + barre collections, qui est masquee sur mobile), mesuree
      // une fois les polices/logo charges. L'announcement bar reste dans le flux.
      var setSpacer = function() {
        var hh = header.offsetHeight || ((headerEl ? headerEl.offsetHeight : 100) + (cnav ? cnav.offsetHeight : 0));
        spacer.style.height = hh + 'px';
      };
      setSpacer();
      window.addEventListener('load', setSpacer);
      window.addEventListener('resize', function() {
        announcementH = announcement ? announcement.offsetHeight : 0;
        setSpacer();
      });
      if (window.ResizeObserver) { new ResizeObserver(setSpacer).observe(header); }
    }

    // Au top de page : cnav visible
    header.classList.add('cnav--visible');

    if (!cnav) return;

    var lastScrollY = window.scrollY;

    window.addEventListener('scroll', function() {
      var y = window.scrollY;
      var delta = y - lastScrollY;

      // Gerer le top du header (announcement bar scroll away)
      var offset = Math.max(0, announcementH - y);
      header.style.setProperty('top', offset + 'px', 'important');

      // Tout en haut : cnav toujours visible
      if (y <= 10) {
        header.classList.add('cnav--visible');
        lastScrollY = y;
        return;
      }

      // Scroll down => cacher cnav
      if (delta > 5) {
        header.classList.remove('cnav--visible');
      }
      // Scroll up => montrer cnav
      else if (delta < -5) {
        header.classList.add('cnav--visible');
      }

      lastScrollY = y;
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFixedHeaderAndCnav);
  } else {
    initFixedHeaderAndCnav();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
